import { Component, Input } from '@angular/core';
import { SimulationTracker } from '../../interfaces/simulation-tracker';
import { SimulationTrackerDataService } from '../../services/simulation-tracker-data.service';

@Component({
  selector: 'app-simulation-tracker-details',
  templateUrl: './simulation-tracker-details.component.html',
})
export class SimulationTrackerDetailsComponent {
  private _simulationTracker?: SimulationTracker | null = null;

  @Input()
  set simulationTracker(value: SimulationTracker | null) {
    this._simulationTracker = value;
  }

  get simulationTracker(): SimulationTracker | null {
    return this._simulationTracker ?? null;
  }

  getStatusMessage(simulationTracker: SimulationTracker): string {
    return SimulationTrackerDataService.MinifiedTrackerStatusMap[
      simulationTracker.status!
    ];
  }

  getStatusColorClass(simulationTracker: SimulationTracker): string {
    return SimulationTrackerDataService.MinifiedTrackerStatusColorMap[
      simulationTracker.status!
    ];
  }
}
